import PriceDisplay from "components/Common/PriceDisplay"

const StockPriceCell = ({ stock }) => {
  return (
    <div className="text-wrap">
      <PriceDisplay
        askingPrice={stock.asking_price}
        discountPrice={stock.discount_price}
      />

      <div className="badge badge-soft-primary mt-1">
        <i className="fas fa-map-marker-alt me-1" style={{ fontSize: 7 }} />
        {stock?.showroom?.name ?? ""} - {stock?.showroom?.short_name ?? ""}
      </div>
    </div>
  )
}

export default StockPriceCell
